import LoggedInBoilerplate from "../LoggedInBoilerplate";
import styled from "styled-components";
import TabularAssignmentHistory from "../../../customUiForCs/tabularAssignmentHistory/TabularAssignmentHistory";
import DailyResponsibility from "../../../customUiForCs/dailyResponsibility/DailyResponsibility";
import { useState } from "react";
import MaterialInput from "../../../helperComponents/MaterialInput";
import DropDownInput from "../../../helperComponents/DropDownInput";
import employeeShiftTypes from "../../../../data/employee/employeeShiftTypes";
import PermissionGuard from "../../../customUiForCs/PermissionGuard";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 80%;
  align-items: center;
  margin-top: 50px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const Row2Section = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
`;

const DataColumn = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
  overflow: visible;
`;

const Filters = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 10px;
  margin-top: 10px;
`;

export default function NewNomenclaturePage() {
  const [date, setDate] = useState(null);
  const [shift, setShift] = useState("12H-DAY");

  let title1 = "Liste de";
  let title2 = "présence";

  return (
    <PermissionGuard permissionName={"presenceListPermissions"} action={"VIEW"}>
      {" "}
      <LoggedInBoilerplate titleLine1={title1} titleLine2={title2}>
        <Column>
          <Filters>
            <MaterialInput
              type="date"
              label={"Date"}
              value={date}
              onChange={(e) => {
                setDate(e.target.value);
              }}
            />

            <DropDownInput
              label={"Shift"}
              options={employeeShiftTypes}
              value={shift}
              onChange={setShift}
            />
          </Filters>
          <DailyResponsibility
            hideAllFilters={true}
            dateProp={date}
            shiftProp={shift}
            hideDateFilter={true}
            hideShiftFilter={true}
            readOnly={true}
          />
          <TabularAssignmentHistory
            dateProp={date}
            shiftProp={shift}
            hideDateFilter={true}
            hideShiftFilter={true}
            readOnly={true}
            disableAllFilters={false}
          />
        </Column>
      </LoggedInBoilerplate>
    </PermissionGuard>
  );
}
